import React from "react";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";

interface StatusFilterProps {
  value: string[];
  onChange: (selected: string[]) => void;
  isStatusEnabled: boolean;
  error?: string;
  statusOptions?: { label: string; value: string }[];
}

const ProviderRequestStatusFilter: React.FC<StatusFilterProps> = ({
  value,
  onChange,
  isStatusEnabled,
  error,
  statusOptions = [],
}) => {
  const handleCheckboxChange = (optionValue: string) => {
    const updated = value.includes(optionValue)
      ? value.filter((val) => val !== optionValue)
      : [...value, optionValue];
    onChange(updated);
  };

  if (!isStatusEnabled) return null;

  return (
    <div className="status-checkbox-list-wrapper">
      <div className="checkbox-list">
        {statusOptions.map((option) => (
          <label
            key={option.value}
            className="checkbox-label"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Checkbox
              checked={value.includes(option.value)}
              onChange={() => handleCheckboxChange(option.value)}
              icon={
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "1px solid #C0C0C0",
                    display: "inline-block",
                  }}
                />
              }
              checkedIcon={
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    backgroundColor: "#1976d2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #1976d2",
                  }}
                >
                  <CheckIcon
                    style={{ fontSize: "17px", color: "#fff", fontWeight: 900 }}
                  />
                </span>
              }
            />
            {option.label}
          </label>
        ))}
      </div>
      {error && (
        <div className="error-message" style={{ textAlign: "left" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default ProviderRequestStatusFilter;
